export default __webpack_public_path__ + "media/images/okButton-1bcaab92b8563895d2c0e1dbdf35afeb.png";